import { useState, useId } from "react";
import { Tooltip } from "react-tooltip";
import { useTranslation } from "react-i18next";

const IconButton = ({
    disabled = false,
    label,
    icon,
    focusIcon,
    showLabel,
    onClick,
    color,
    hasHoverColor = false,
    hoverColor,
    tooltipPlace = "top-start",
}) => {
    const { t } = useTranslation();
    const [focus, setFocus] = useState(false);
    if (hasHoverColor)
        hoverColor = `icon-button-hover--${hoverColor || "bleu-a2"}`;

    const id = `iconBtn-${useId().replace(/[:]/g, "")}`;

    return (
        <button
            disabled={disabled}
            type="button"
            className={`icon-button icon-button--${color || "bleu-a2"} ${hoverColor}`}
            onClick={onClick}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            onMouseEnter={() => setFocus(true)}
            onMouseLeave={() => setFocus(false)}
            data-tooltip-id={id}
            data-tooltip-content={t(label)}
        >
            <i className={focus ? focusIcon : icon} data-tip={t(label)} />
            <span className={showLabel ? "" : "sr-only"}>{t(label)}</span>
            <Tooltip
                id={id}
                place={tooltipPlace}
                opacity={1}
                className="tooltip"
                border="1px solid #5e92ff"
            />
        </button>
    );
};

export default IconButton;
